import { apiSlice } from "../api/apiSlice";

export const videosApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => "/videos",
    }),
    getVideo: builder.query({
      query: (videoId) => `/videos/${videoId}`,
    }),
    createVideo: builder.mutation({
      query: (data) => ({
        url: "/videos",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result?.data?.id) {
            // passimistically update the video
            dispatch(
              apiSlice.util.updateQueryData("getVideos", undefined, (data) => {
                data.push(result.data);
              })
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    updateVideo: builder.mutation({
      query: (data) => ({
        url: `/videos/${data.id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result?.data?.id) {
            // passimistically update the video
            dispatch(
              apiSlice.util.updateQueryData("getVideos", undefined, (data) => {
                const video = data.find((video) => video.id === result.data.id);
                video.title = result.data.title;
                video.url = result.data.url;
                video.duration = result.data.duration;
                video.description = result.data.description;
              })
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    deleteVideo: builder.mutation({
      query: (videoId) => ({
        url: `/videos/${videoId}`,
        method: "DELETE",
      }),
      async onQueryStarted(videoId, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result?.meta?.response?.status === 200) {
            // passimistically delete the video
            dispatch(
              apiSlice.util.updateQueryData(
                "getVideos",
                undefined,
                (videos) => {
                  // eslint-disable-next-line eqeqeq
                  const deletedVideo = videos.filter(
                    (video) => video.id !== videoId
                  );
                  return deletedVideo;
                }
              )
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
  }),
});

export const {
  useGetVideosQuery,
  useGetVideoQuery,
  useCreateVideoMutation,
  useUpdateVideoMutation,
  useDeleteVideoMutation,
} = videosApi;
